// @flow

import React, { useState } from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";
import { ShiftPatternTable } from "@modules/shared/components";
import type { EmployeePosition } from "@modules/shared/reducer/types";
import type { EmployeeAbsence } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  absence: EmployeeAbsence,
  employee: Object,
  bankHolidays: Array<string>,
  captureBankHolidays: boolean,
  shiftPatternDays: Array<{}>,
  timeLostShiftPattern: Array<{}>,
  minimumAbsenceDuration: number, // wtf????
  onSubmit: (shiftPatternList: Array<Object>) => void,
  onChange: (shiftPatternList: Array<Object>) => void,
  onDismissHandler: () => void,
  ...PropsFromLocalize,
}>;

function EditEmployeeShiftPatternModal(props: Props) {
  const [shiftPattern, setShiftPattern] = useState([]);
  const [isValidTimeLossData, setIsValidTimeLossData] = useState([]);

  function onChange(shiftPattern) {
    setShiftPattern(shiftPattern);
  }

  function onSubmit() {
    props.onSubmit(shiftPattern);
  }

  return (
    <Modal className="modal-large">
      <ModalHeader toggle={props.onDismissHandler}>
        {props.t("SHIFT_PATTERN_WITH_ID", { id: props.absence.id })}
      </ModalHeader>
      <ModalBody>
        <ShiftPatternTable
          absence={props.absence}
          employeePositions={props.employee.employmentSummary.positions
            .filter(i => i.isActive)
            .map(e => ({
              value: e.id,
              label: e.jobTitle,
            }))}
          onValidate={setIsValidTimeLossData}
          onChange={onChange}
          onSubmit={onSubmit}
          timeLostShiftPattern={props.timeLostShiftPattern}
          shiftPatternDays={props.shiftPatternDays}
          bankHolidays={props.bankHolidays}
          captureBankHolidays={props.captureBankHolidays}
          minimumAbsenceDuration={props.minimumAbsenceDuration}
          showRepeatButton
        />
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={props.onDismissHandler}>
          {props.t("CANCEL")}
        </Button>
        <Button materialIcon="save" onClick={onSubmit} disabled={!isValidTimeLossData}>
          {props.t("SAVE")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default localize()(EditEmployeeShiftPatternModal);
